import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import Box from '@mui/material/Box';
import Icon from 'common/components/Elements/Icon/Icon';
import { isUnits } from 'core/api/api.typesGuards';
import type * as I from 'core/api/coreApiClient';
import DropDown from 'core/components/Elements/DropDown/DropDown';
import React from 'react';

interface ComponentProps {
  currentUnitId?: string;
  units: I.Unit[] | I.UnitValue[];
  onChange: (unitId: string) => void;
}

function UnitDropdown({ currentUnitId, units: unitsProp, onChange }: ComponentProps) {
  let units: I.UnitValue[] = [];
  if (isUnits(unitsProp)) {
    units = unitsProp.map((u) => ({ unitId: u.id, unitLabel: u.label, unitHtmlLabel: u.htmlLabel }));
  } else {
    units = unitsProp;
  }

  return (
    <Box sx={{
      display: 'inline-block',
      ml: 0.5,
      height: '20px',
      mt: '-10px',
      verticalAlign: 'middle',
    }}
    >
      <DropDown
        id="switchUnit"
        action="tertiary"
        title="Change Unit"
        items={units.map((u) => ({
          id: u.unitId,
          label: currentUnitId === u.unitId ? `${u.unitLabel} (selected)` : u.unitLabel,
           
          htmlLabel: u.unitHtmlLabel
            ? (currentUnitId === u.unitId ? `${u.unitHtmlLabel} (selected)` : u.unitHtmlLabel)
            : undefined,
          title: u.unitLabel,
          active: currentUnitId !== u.unitId,
          commands: [],
          onClick: () => onChange(u.unitId),
        }))}
        arrowIcon={<Icon element={OpenInFullIcon} rotate={45} style={{ width: '18px' }} color="primary" />}
      />
    </Box>
  );
}

export default UnitDropdown;
